module.exports = __webpack_public_path__ + "img/summary-back.ddba514e.png";